import {
  BASE_FONT_SIZE,
  BLOCK_VERTICAL_PADDING,
} from "@gameComponents/MiniGame/OrderOverview/Snapshot/constants";
import { miniGameOrderOverviewSnapshotDrawUserWinRate } from "@gameComponents/MiniGame/OrderOverview/Snapshot/helpers/drawUserWinRate";
import { miniGameOrderOverviewSnapshotDrawUserWinStreak } from "@gameComponents/MiniGame/OrderOverview/Snapshot/helpers/drawWinStreak";
import colors from "tailwindcss/colors";

interface Params {
  context: CanvasRenderingContext2D;
  winRate: number;
  winStreak: number;
  translateX: number;
  translateY: number;
  width: number;
  isWin: boolean;
}

const GAP = 8;

export function miniGameOrderOverviewSnapshotDrawUserPerformance(
  params: Params,
): void {
  const { context, winRate, winStreak, translateX, translateY, width, isWin } =
    params;

  const halfWidth = width / 2;
  const rectangleWidth = halfWidth - GAP / 2;
  const initialY = translateY + BLOCK_VERTICAL_PADDING + BASE_FONT_SIZE;

  const chevronDirection = isWin ? "up" : "down";
  const chevronColor = isWin ? colors.green[500] : colors.red[500];

  miniGameOrderOverviewSnapshotDrawUserWinRate({
    context,
    x: translateX,
    y: translateY,
    width: rectangleWidth,
    label: "Win Rate",
    value: `🎯 ${winRate}%`,
    initialY,
    chevronDirection,
    chevronColor,
  });

  const secondRectangleX = translateX + rectangleWidth + GAP;
  miniGameOrderOverviewSnapshotDrawUserWinStreak({
    context,
    x: secondRectangleX,
    y: translateY,
    width: rectangleWidth,
    label: "Win Streak",
    winStreak,
    initialY,
    chevronDirection,
    chevronColor,
  });
}
